import { Link } from "react-router-dom";
import { LOGOS } from "@/lib/brand";
import { useT } from "@/lib/i18n";
import { useConsent } from "@/lib/consent";

export default function Footer() {
  const { t } = useT();
  const { openPreferences } = useConsent();

  return (
    <footer
      className="border-t border-border/60 mt-12 py-8 bg-background/40"
      data-testid="app-footer"
    >
      <div className="mx-auto max-w-6xl px-4 sm:px-8 flex flex-col items-center gap-4">
        <span className="text-[10px] uppercase tracking-[0.22em] text-slate-500">
          {t("footer.developedBy")}
        </span>
        <a
          href={LOGOS.developerUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="group inline-flex items-center justify-center transition-transform hover:scale-[1.03]"
          aria-label={LOGOS.developerName}
          data-testid="dev-brand-footer"
        >
          <img
            src={LOGOS.developer}
            alt={LOGOS.developerName}
            className="h-7 sm:h-8 w-auto object-contain opacity-90 group-hover:opacity-100 transition-opacity"
          />
        </a>
        <nav
          className="flex items-center gap-4 flex-wrap justify-center text-xs text-slate-500 mt-1"
          aria-label="Legal"
        >
          <Link
            to="/impressum"
            className="hover:text-slate-300 transition-colors"
            data-testid="footer-imprint"
          >
            {t("footer.imprint")}
          </Link>
          <span aria-hidden="true">·</span>
          <Link
            to="/datenschutz"
            className="hover:text-slate-300 transition-colors"
            data-testid="footer-privacy"
          >
            {t("footer.privacy")}
          </Link>
          <span aria-hidden="true">·</span>
          <button
            type="button"
            onClick={openPreferences}
            className="hover:text-slate-300 transition-colors underline decoration-dotted underline-offset-2"
            data-testid="footer-cookie-prefs"
          >
            {t("footer.cookiePrefs")}
          </button>
        </nav>
      </div>
    </footer>
  );
}
